import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { ExternalAccountsPage } from '@egw/features-external-accounts'

export const SettingsExternalAccountsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <ExternalAccountsPage />
    </Layout>
  )
}
